<template>
  <div class="bilibili-form-container">
    <el-card class="form-card" shadow="hover">
      <template #header>
        <div class="card-header">
          <el-icon>
            <Database />
          </el-icon>
          <span>B站用户积分管理</span>
        </div>
      </template>

      <el-form ref="userFormRef" :model="userForm" :rules="formRules" label-width="100px" class="user-form">
        <!-- B站UID -->
        <el-form-item label="B站UID" prop="uid">
          <el-input v-model="userForm.uid" placeholder="请输入B站UID" @keyup.enter="submitForm" @input="handleUidInput" />
        </el-form-item>

        <!-- 昵称 -->
        <el-form-item label="昵称" prop="name">
          <el-input v-model="userForm.name" placeholder="请输入用户昵称（选填）" @keyup.enter="submitForm" />
        </el-form-item>

        <!-- 积分 -->
        <el-form-item label="积分" prop="integral">
          <el-input-number v-model="userForm.integral" placeholder="请输入积分" @keyup.enter="submitForm" />
        </el-form-item>

        <!-- 记录 -->
        <el-form-item label="记录" prop="Recording">
          <el-input v-model="userForm.Recording" placeholder="请输入记录（例：2025.6上舰+8;兑换围巾-20）" type="textarea" :rows="4"
            @keyup.enter="submitForm" />
        </el-form-item>

        <!-- 操作按钮 -->
        <el-form-item style="text-align: center; margin-top: 20px;">
          <el-button type="primary" :loading="submitLoading" @click="submitForm">
            提交
          </el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import axios from 'axios';
import { Database, Info, Loading } from '@element-plus/icons-vue';

// 表单引用
const userFormRef = ref(null);

// 表单数据
const userForm = reactive({
  uid: '',
  name: '',
  integral: '',
  Recording: ''
});

// 表单验证规则
const formRules = reactive({
  uid: [
    { required: true, message: '请输入B站UID', trigger: 'blur' },
    { pattern: /^\d+$/, message: 'B站UID只能包含数字', trigger: 'blur' }
  ],
  name: [], // 昵称设为选填
  integral: [
    { required: true, message: '请输入积分', trigger: 'blur' },
    { type: 'number', message: '请输入有效数字', trigger: 'blur' }
  ],
  Recording: [
    { required: true, message: '请输入记录', trigger: 'blur' },
  ]
});

// 提交状态
const submitLoading = ref(false);

// 处理UID只能输入数字
const handleUidInput = (value) => {
  // 只保留数字
  userForm.uid = value.replace(/\D/g, '');
};

// 提交表单
const submitForm = () => {
  userFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        submitLoading.value = true;
        
        // 发送POST请求
        const response = await axios.post('/adminapi/integral/add', {
          uid: userForm.uid,
          name: userForm.name,
          integral: userForm.integral,
          Recording: userForm.Recording
        });
        
        // 处理响应
        if (response.data && response.data.code === 200) {
          if(response.data.message === '积分不能为负数'){
            ElMessage.error('积分不足');
          }
          ElMessage.success('积分记录添加成功');
          resetForm();
        } else {
          ElMessage.error(response.data.message || '提交失败，请重试');
        }
      } catch (error) {
        console.error('提交错误:', error);
        ElMessage.error('网络错误，请检查连接');
      } finally {
        submitLoading.value = false;
      }
    } else {
      ElMessage.error('请检查表单输入');
      return false;
    }
  });
};

// 重置表单
const resetForm = () => {
  userFormRef.value.resetFields();
};

onMounted(() => {
  // 初始化焦点到UID输入框
  const uidInput = document.querySelector('input[placeholder="请输入B站UID"]');
  if (uidInput) {
    uidInput.focus();
  }
});
</script>

<style lang="scss" scoped>
.bilibili-form-container {
  padding: 30px;
  max-width: 800px;
  margin: 0 auto;

  .form-card {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    }
  }

  .card-header {
    display: flex;
    align-items: center;
    color: #303133;
    font-size: 18px;
    font-weight: 500;

    .el-icon {
      margin-right: 10px;
      color: #409eff;
    }
  }

  .user-form {
    .el-form-item {
      margin-bottom: 20px;
    }

    .el-input,
    .el-input-number {
      &::v-deep {
        .el-input__inner {
          border-radius: 4px;
          transition: border-color 0.3s, box-shadow 0.3s;
        }

        &:focus-within .el-input__inner {
          border-color: #409eff;
          box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
        }
      }
    }

    .record-hint {
      display: flex;
      align-items: center;
      margin-top: 8px;
      color: #909399;
      font-size: 12px;
    }
  }
}
</style>